import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngInputBase } from '../../inputs';

@Component({
  selector: 'ing-radio-button',
  templateUrl: './ing-radio-button.component.html',
  styleUrls: ['./ing-radio-button.component.scss']
})
export class IngRadioButtonComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngInputBase<boolean>;

  constructor() { }

  ngOnInit() {
    this.form.controls[this.input.key].setValue(this.form.controls[this.input.key].value || false);
  }

  changeEvent($event) {
    if ($event != this.form.controls[this.input.key].value) {
      this.form.controls[this.input.key].setValue($event);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/ing-radio-button/ing-radio-button.component.ts